import React from "react"
import CCMEditCareView from "../components/CCMAdmin/CCMEditCare/CCMEditCare"

const CCMEditCare = () => <CCMEditCareView />

export default CCMEditCare
